import { render, staticRenderFns } from "./Opinion.vue?vue&type=template&id=69b033fe&scoped=true"
import script from "./Opinion.vue?vue&type=script&lang=js"
export * from "./Opinion.vue?vue&type=script&lang=js"
import style0 from "./Opinion.vue?vue&type=style&index=0&id=69b033fe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69b033fe",
  null
  
)

export default component.exports